import React, { useEffect } from "react";
import './App.css';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { authManager } from './utils/auth';
import Layout from './Components/Layout';
import Login from './Screens/Login';
import Authentication from './Screens/Authentication';
import Forget from "./Screens/Forget";
import Dashboard from "./Screens/Dashboard";
import User from "./Screens/User";
import InviteUser from "./Screens/InviteUser";
import Password from "./Screens/Password";
import AuthenticationLogin from "./Screens/Authentication_login";
import InsiderDashboard from "./Screens/Insider_Dashboard";
import BrandView from "./Screens/Brand_View";
import Brand from "./Screens/Brand";
import Product from "./Screens/Product";
import BrandEdit from "./Screens/Brand_Edit";
import ProductView  from "./Screens/Product_View";
import ProductEdit from "./Screens/Product_Edit";
import UsersView  from "./Screens/Users_View";
import UsersEdit  from "./Screens/Users_Edit";
import { UserProvider } from './contexts/UserContext';
import ProtectedRoute from './Components/ProtectedRoute';
import Profile from "./Screens/Profile";
import Category from "./Screens/Category";
import CategoryView from "./Screens/Category_View";
import CategoryEdit from "./Screens/Category_Edit";
import CategoryAdd from "./Screens/Category_Add";
import CategoryMapping from "./Screens/Category_Mapping";
import ResetPassword from "./Screens/ResetPassword";
import Cca from "./Screens/CampaignCcaAnalytics.js";
import Denali from "./Screens/CampaignDenali.js";
import Insider from "./Screens/CampaignInsider.js";
import Insurance from "./Screens/CampaignInsurance.js";
import Lifestyle from "./Screens/CampaignLifestyle.js";
import NextTrip from "./Screens/CampaignNextTrip.js";
import Vausa from "./Screens/CampaignVausa.js";
import Voice from "./Screens/CampaignVoice.js";
import LoyaltyReceipts from "./Screens/LoyaltyReceipts.js";
import LoyaltyRedemptions from "./Screens/LoyaltyRedemptions.js";
import LoyaltyUnlocks from "./Screens/LoyaltyUnlocks.js";
import LoyaltyRules from "./Screens/LoyaltyRules.js";
import UploadLoyaltyReceipt from "./Screens/UploadLoyaltyReceipt.js";
import UnclaimedLoyaltyReceipts from "./Screens/UnclaimedLoyaltyReceipts.js";
import EditLoyaltyReceipt from "./Screens/EditLoyaltyReceipt.js";
import LoyaltyInsights from "./Screens/LoyaltyInsights.js";
import LoyaltyMember from "./Screens/LoyaltyMember.js";
import LoyaltyProductInsights from "./Screens/LoyaltyProductInsights.js";
import ServiceBenefits from "./Screens/ServiceBenefits.js";
import ServiceBenefitsView from "./Screens/ServiceBenefitsView.js";
import ServiceBenefitsAdd from "./Screens/ServiceBenefitsAdd.js";
import ProgramFlags from "./Screens/ProgramFlags.js";
import ProgramFlagsView from "./Screens/ProgramFlagsView.js";
import ProgramFlagsAdd from "./Screens/ProgramFlagsAdd.js";
import DropdownOptions from "./Screens/DropdownOptions.js";
import DropdownOptionsAdd from "./Screens/DropdownOptionsAdd.js";
import OidcClients from "./Screens/OidcClients.js";
import OidcClientsAdd from "./Screens/OidcClientsAdd.js";
import OidcClientsView from "./Screens/OidcClientsView.js";
import PartnerInquiries from "./Screens/PartnerInquiries.js";
import PartnerInquiriesView from "./Screens/PartnerInquiriesView.js";
import QuizQuestions from "./Screens/QuizQuestions.js";
import QuizQuestionsAdd from "./Screens/QuizQuestionsAdd.js";
import QuizReportRules from "./Screens/QuizReportRules.js";
import QuizReportRulesAdd from "./Screens/QuizReportRulesAdd.js";
import QuizLeads from "./Screens/QuizLeads.js";
import Referrals from "./Screens/Referrals.js";
import VaBenefits from "./Screens/VaBenefits.js";
import VaBenefitsAdd from "./Screens/VaBenefitsAdd.js";

function AppRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize authManager on app startup to restore session and start timers
    authManager.init();
    
    const logoutHandler = () => navigate('/');
    window.addEventListener('auth:logout', logoutHandler);
    window.addEventListener('auth:inactivity-logout', logoutHandler);
    return () => {
      window.removeEventListener('auth:logout', logoutHandler);
      window.removeEventListener('auth:inactivity-logout', logoutHandler);
    };
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/authentication" element={<Authentication />} />
      <Route path="/forget" element={<Forget />} />
      <Route path="/invite/accept" element={<Password />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/authenticate" element={<AuthenticationLogin />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<User />} />
        <Route path="/users/:id" element={<UsersView />} />
        <Route path="/usersedit/:id" element={<UsersEdit  />} />
        <Route path="/inviteUser" element={<InviteUser />} />
        <Route path="/mmi-dashboard" element={<InsiderDashboard />} />
        <Route path="/brands" element={<Brand />} />
        <Route path="/brands/:id" element={<BrandView />} />
        <Route path="/products" element={<Product />} />
        <Route path="/brandsedit/:id" element={<BrandEdit />} />
        <Route path="/products/:id" element={<ProductView  />} />
        <Route path="/productsedit/:id" element={<ProductEdit />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/category" element={<Category />} />
        <Route path="/categoryView/:id" element={<CategoryView />} />
        <Route path="/categoryedit/:id" element={<CategoryEdit />} />
        <Route path="/categoryAdd" element={<CategoryAdd />} />
        <Route path="/categoryMapping" element={<CategoryMapping />} />
        <Route path="/analytics" element={<Cca/>} />
        <Route path="/nextTrip" element={<NextTrip/>} />
        <Route path="/vausa" element={<Vausa/>} />
        <Route path="/denali" element={<Denali/>} />
        <Route path="/insider" element={<Insider/>} />
        <Route path="/insurance" element={<Insurance/>} />
        <Route path="/lifestyle" element={<Lifestyle/>} />
        <Route path="/voice" element={<Voice/>} />
        <Route path="/loyaltyReceipts" element={<LoyaltyReceipts/>} />
        <Route path="/loyaltyReceipts/upload" element={<UploadLoyaltyReceipt/>} />
        <Route path="/loyaltyReceipts/unclaimed" element={<UnclaimedLoyaltyReceipts/>} />
        <Route path="/loyaltyReceipts/:id/edit" element={<EditLoyaltyReceipt/>} />
        <Route path="/loyaltyInsights" element={<LoyaltyInsights/>} />
        <Route path="/loyaltyMembers/:id" element={<LoyaltyMember/>} />
        <Route path="/loyaltyProductInsights" element={<LoyaltyProductInsights/>} />
        <Route path="/loyaltyRedemptions" element={<LoyaltyRedemptions/>} />
        <Route path="/loyaltyUnlocks" element={<LoyaltyUnlocks/>} />
        <Route path="/loyaltyRules" element={<LoyaltyRules/>} />
        <Route path="/serviceBenefits" element={<ServiceBenefits/>} />
        <Route path="/serviceBenefitsView/:id" element={<ServiceBenefitsView/>} />
        <Route path="/serviceBenefitsAdd" element={<ServiceBenefitsAdd/>} />
        <Route path="/serviceBenefitsAdd/:id" element={<ServiceBenefitsAdd/>} />
        <Route path="/programFlags" element={<ProgramFlags/>} />
        <Route path="/programFlagsView/:id" element={<ProgramFlagsView/>} />
        <Route path="/programFlagsAdd" element={<ProgramFlagsAdd/>} />
        <Route path="/programFlagsAdd/:id" element={<ProgramFlagsAdd/>} />
        <Route path="/dropdownOptions" element={<DropdownOptions/>} />
        <Route path="/dropdownOptionsAdd" element={<DropdownOptionsAdd/>} />
        <Route path="/dropdownOptionsAdd/:id" element={<DropdownOptionsAdd/>} />
        <Route path="/oidcClients" element={<OidcClients/>} />
        <Route path="/oidcClientsView/:clientId" element={<OidcClientsView/>} />
        <Route path="/oidcClientsAdd" element={<OidcClientsAdd/>} />
        <Route path="/oidcClientsAdd/:clientId" element={<OidcClientsAdd/>} />
        <Route path="/partnerInquiries" element={<PartnerInquiries/>} />
        <Route path="/partnerInquiriesView/:id" element={<PartnerInquiriesView/>} />
        <Route path="/quizQuestions" element={<QuizQuestions/>} />
        <Route path="/quizQuestionsAdd" element={<QuizQuestionsAdd/>} />
        <Route path="/quizQuestionsAdd/:id" element={<QuizQuestionsAdd/>} />
        <Route path="/quizReportRules" element={<QuizReportRules/>} />
        <Route path="/quizReportRulesAdd" element={<QuizReportRulesAdd/>} />
        <Route path="/quizReportRulesAdd/:id" element={<QuizReportRulesAdd/>} />
        <Route path="/quizLeads" element={<QuizLeads/>} />
        <Route path="/referrals" element={<Referrals/>} />
        <Route path="/vaBenefits" element={<VaBenefits/>} />
        <Route path="/vaBenefitsAdd" element={<VaBenefitsAdd/>} />
        <Route path="/vaBenefitsAdd/:id" element={<VaBenefitsAdd/>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
          <AppRoutes />
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;
